import { BW_LANGUAGE_EN } from 'src/libs/qb-brand-web-components'

const brandConfig = {
  brandId: 'qbx_vip',
  name: 'QBX VIP Club',
  // faqEmail: 'support-qbxvipclub@qiibee.com',
  faqUrl:
    'https://qiibee.notion.site/QBX-VIP-CLUB-FAQ-1a07a68e7e1d80bca29ff3c4a066b0a6',
  helpCenterUrl:
    'https://qiibee.notion.site/qbx-vip-club-help-center?v=1a07a68e7e1d814f851e000ccc436f66&pvs=4',
  websiteUrl: 'https://qiibeefoundation.org/qbx-vip-club/',
  termsUrl: 'https://static.qiibee.com/rewards/terms.pdf',
  privacyPolicyUrl: 'https://www.qiibee.com/privacy-policy/',
  cookiePolicyUrl: 'https://static.qiibee.com/rewards/cookiepolicy.pdf',
  theme: {
    palette: {
      lighter: '#FEF4D4',
      light: '#FED680',
      main: '#fda92d',
      dark: '#B66816',
      darker: '#793908',
      contrastText: '#1C252E'
    },
    colors: {
      main: '#2d2d2d',
      accent: '#000000'
    }
  },
  supportedLanguages: [BW_LANGUAGE_EN],
  features: {
    enableImpactReport: true,
    enableRootImpactReport: true,
    homeBanners: true,
    enableCOEStorefront: true,
    staking: false, // @TODO: Need to enable when staking is ready
    rewardBoxes: true
  },
  cognito: {
    region: 'eu-central-1',
    poolId: 'eu-central-1_6bu4ynztS',
    clientId: 'f5j7n0vp8lsblqltvjkhor832',
    poolDomain: 'qbxvip.auth.eu-central-1.amazoncognito.com',
    redirectUri: 'https://vip.qiibeefoundation.org/login'
  },
  gaTrackingId: 'G-VSXV21SVWW',
  hotjarId: '3125123'
}

export default brandConfig
